(() => {
  if (window.__mingsilkContactR2) return;
  window.__mingsilkContactR2 = true;

  const mobileQuery = window.matchMedia('(max-width: 749.98px)');
  const instances = new WeakMap();

  const parseCopy = (root) => {
    try {
      return JSON.parse(root.querySelector('[data-reverie-contact-copy]')?.textContent || '{}');
    } catch (_error) {
      return {};
    }
  };

  const init = (root) => {
    if (!root || instances.has(root)) return;

    const form = root.querySelector('#ReverieContactForm');
    const launcher = root.querySelector('[data-r2-contact-open]');
    const closer = root.querySelector('[data-r2-contact-close]');
    const originalSteps = [...root.querySelectorAll('[data-reverie-contact-step]')];
    const reviewStep = root.querySelector('[data-r2-contact-review]');
    const originalProgress = [...root.querySelectorAll('[data-reverie-contact-progress]')];
    const reviewProgress = root.querySelector('[data-r2-contact-progress="4"]');
    const nextButton = root.querySelector('[data-reverie-contact-next]');
    const backButton = root.querySelector('[data-reverie-contact-back]');
    const submitButton = root.querySelector('[data-reverie-contact-submit]');
    const emailDirect = root.querySelector('[data-reverie-contact-email-direct]');
    const guidance = root.querySelector('[data-reverie-contact-guidance]');
    const formBody = root.querySelector('.reverie-contact-form__body');
    const desktopConsent = root.querySelector('[data-r2-desktop-consent] input');
    const mobileConsent = root.querySelector('[data-r2-mobile-consent] input');
    const whatsappField = root.querySelector('[data-r2-whatsapp-field]');
    const whatsappNumber = root.querySelector('[data-reverie-contact-number]');
    const dialCode = root.querySelector('[data-reverie-contact-dial]');
    const country = root.querySelector('[data-reverie-contact-country]');
    const email = root.querySelector('#ReverieContactForm-email');
    const copy = parseCopy(root);

    if (!form || originalSteps.length !== 3 || !reviewStep) return;

    root.querySelectorAll('.msv8-channel:not([data-r2-contact-channel])').forEach((channel) => channel.remove());

    const channelField = root.querySelector('[data-r2-contact-channel]');
    const channelInputs = [...root.querySelectorAll('[data-r2-contact-channel] input[name="msv8_channel"]')];
    const preferredContact = form.querySelector('input[name="contact[preferred_contact]"]');
    const progressItems = [...originalProgress, reviewProgress].filter(Boolean);
    let currentStep = 1;
    let isOpen = false;
    let savedScrollY = 0;
    let touchStart = null;

    const isMobile = () => mobileQuery.matches;

    const selectedChannel = () =>
      channelInputs.find((input) => input.checked)?.value === 'WhatsApp' ? 'WhatsApp' : 'Email';

    const updateViewportHeight = () => {
      const height = window.visualViewport?.height || window.innerHeight;
      root.style.setProperty('--r2-contact-viewport-height', `${Math.round(height)}px`);
    };

    const updateChannel = () => {
      const isWhatsApp = selectedChannel() === 'WhatsApp';
      if (whatsappField) whatsappField.hidden = !isWhatsApp;
      [dialCode, whatsappNumber].forEach((field) => {
        if (!field) return;
        field.disabled = !isWhatsApp;
        field.required = isWhatsApp;
        field.setAttribute('aria-required', String(isWhatsApp));
      });
      if (preferredContact) preferredContact.value = isWhatsApp ? 'WhatsApp' : 'Email';
      syncReview();
    };

    const reviewValue = (key, value) => {
      const target = root.querySelector(`[data-r2-review="${key}"]`);
      if (target) target.textContent = value || copy.summaryEmpty || 'Not selected';
    };

    function syncReview() {
      const inquiryType = form.querySelector('input[name="contact[inquiry_type]"]:checked')?.value;
      const intendedUse = form.querySelector('[data-reverie-contact-summary-source="use"]')?.value;
      const quantity = form.querySelector('[data-reverie-contact-summary-source="quantity"]')?.value;
      reviewValue('type', inquiryType);
      reviewValue('use', intendedUse);
      reviewValue('quantity', quantity);
      reviewValue('country', country?.value);

      const reviewEmail = root.querySelector('[data-r2-review-email]');
      const reviewChannel = root.querySelector('[data-r2-review-channel]');
      if (reviewEmail) reviewEmail.textContent = email?.value || copy.summaryEmpty || 'Not selected';
      if (reviewChannel) reviewChannel.textContent = selectedChannel();
    }

    const requiredFieldsForStep = (stepNumber) => {
      if (stepNumber === 4) return mobileConsent ? [mobileConsent] : [];
      const panel = originalSteps[stepNumber - 1];
      return panel ? [...panel.querySelectorAll('[required]:not(:disabled)')] : [];
    };

    const validateStep = (stepNumber) => {
      const invalidField = requiredFieldsForStep(stepNumber).find((field) => !field.checkValidity());
      if (!invalidField) return true;

      invalidField.reportValidity();
      invalidField.focus({ preventScroll: true });
      invalidField.scrollIntoView({ block: 'center', behavior: 'smooth' });
      return false;
    };

    const setStep = (nextStep, direction = 1) => {
      currentStep = Math.max(1, Math.min(4, nextStep));
      root.dataset.r2ContactDirection = direction < 0 ? 'back' : 'next';

      originalSteps.forEach((panel, index) => {
        const active = index === currentStep - 1;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });

      const reviewActive = currentStep === 4;
      reviewStep.hidden = !reviewActive;
      reviewStep.classList.toggle('is-active', reviewActive);

      progressItems.forEach((item, index) => {
        const itemStep = index + 1;
        item.hidden = !isMobile() && itemStep === 4;
        item.classList.toggle('is-active', itemStep === currentStep);
        item.classList.toggle('is-complete', itemStep < currentStep);
      });

      if (backButton) backButton.hidden = currentStep === 1;
      if (nextButton) nextButton.hidden = currentStep === 4;
      if (submitButton) submitButton.hidden = currentStep !== 4;
      if (emailDirect) emailDirect.hidden = true;

      const nextLabel = nextButton?.querySelector('[data-reverie-contact-next-label]');
      if (nextLabel) nextLabel.textContent = copy.nextLabels?.[String(currentStep)] || nextLabel.textContent;
      if (guidance) guidance.hidden = true;

      syncReview();
      const activePanel = currentStep === 4 ? reviewStep : originalSteps[currentStep - 1];
      activePanel?.scrollTo({ top: 0, behavior: 'auto' });
      window.setTimeout(() => activePanel?.focus?.({ preventScroll: true }), 240);
    };

    const setConsentMode = (mobileMode) => {
      if (desktopConsent) desktopConsent.disabled = mobileMode;
      if (mobileConsent) mobileConsent.disabled = !mobileMode;
    };

    const openTask = () => {
      if (!isMobile() || isOpen) return;
      isOpen = true;
      savedScrollY = window.scrollY;
      updateViewportHeight();
      setConsentMode(true);
      root.classList.add('is-r2-task-open');
      document.documentElement.classList.add('is-r2-contact-locked');
      document.body.classList.add('is-r2-contact-locked');
      document.body.style.top = `-${savedScrollY}px`;
      setStep(currentStep, 1);
      window.setTimeout(() => closer?.focus(), 30);
    };

    const closeTask = () => {
      if (!isOpen) return;
      isOpen = false;
      root.classList.remove('is-r2-task-open');
      document.documentElement.classList.remove('is-r2-contact-locked');
      document.body.classList.remove('is-r2-contact-locked');
      document.body.style.top = '';
      setConsentMode(false);
      window.scrollTo({ top: savedScrollY, behavior: 'auto' });
      launcher?.focus({ preventScroll: true });
    };

    const handleNext = () => {
      if (validateStep(currentStep)) setStep(currentStep + 1, 1);
    };

    const handleBack = () => setStep(currentStep - 1, -1);

    const interceptTaskButtons = (event) => {
      if (!isMobile() || !isOpen) return;
      if (event.target.closest('[data-reverie-contact-next]')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        handleNext();
      } else if (event.target.closest('[data-reverie-contact-back]')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        handleBack();
      }
    };

    const handleSubmit = (event) => {
      if (!isMobile() || !isOpen) return;
      for (let step = 1; step <= 4; step += 1) {
        if (!validateStep(step)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          setStep(step, step < currentStep ? -1 : 1);
          return;
        }
      }
      syncReview();
    };

    const ignoredSwipeTarget = (target) =>
      target.closest('input, select, textarea, button, a, summary, details, [role="button"]');

    const handleTouchStart = (event) => {
      if (!isMobile() || !isOpen || event.touches.length !== 1 || ignoredSwipeTarget(event.target)) return;
      const touch = event.touches[0];
      if (touch.clientX < 24 || touch.clientX > window.innerWidth - 24) return;
      touchStart = { x: touch.clientX, y: touch.clientY };
    };

    const handleTouchEnd = (event) => {
      if (!touchStart || event.changedTouches.length !== 1) return;
      const touch = event.changedTouches[0];
      const deltaX = touch.clientX - touchStart.x;
      const deltaY = touch.clientY - touchStart.y;
      touchStart = null;
      if (Math.abs(deltaX) < 60 || Math.abs(deltaX) < Math.abs(deltaY) * 1.2) return;
      if (deltaX < 0) handleNext();
      else if (currentStep > 1) handleBack();
    };

    const handleMediaChange = () => {
      if (!isMobile() && isOpen) closeTask();
      setConsentMode(isMobile() && isOpen);
      reviewProgress.hidden = !isMobile();
    };

    launcher?.addEventListener('click', openTask);
    closer?.addEventListener('click', closeTask);
    form.addEventListener('click', interceptTaskButtons, true);
    form.addEventListener('submit', handleSubmit, true);
    form.addEventListener('input', syncReview);
    form.addEventListener('change', syncReview);
    channelField?.addEventListener('change', updateChannel);
    formBody?.addEventListener('touchstart', handleTouchStart, { passive: true });
    formBody?.addEventListener('touchend', handleTouchEnd, { passive: true });
    mobileQuery.addEventListener('change', handleMediaChange);
    window.visualViewport?.addEventListener('resize', updateViewportHeight);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && isOpen) closeTask();
    });

    setConsentMode(false);
    updateChannel();
    syncReview();
    reviewProgress.hidden = !isMobile();

    instances.set(root, { closeTask });
  };

  const initAll = () => document.querySelectorAll('[data-reverie-contact]').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => window.setTimeout(initAll, 0), { once: true });
  } else {
    window.setTimeout(initAll, 0);
  }

  document.addEventListener('shopify:section:load', (event) => {
    window.setTimeout(() => init(event.target.querySelector('[data-reverie-contact]')), 0);
  });
})();
